<template>
  <v-card
    class="mx-auto"
    width="542"
    style="border-radius: 10px;"
    :elevation="3"
    :style="{ opacity:  data.old ? 0.4 : 1 }"
  >
    <v-img
      :src="image"
      :height="height"
    >
    </v-img>

    <v-card-title 
      color="red"
      :style="{ color: activityColor1 ? activityColor1 : color1 }"
    >
      <div class="time"
        :style="{ 'top': `${height-30}px`, 'background-color': active ? 'rgb(202, 202, 82)' : activityColor2 ? activityColor2 : color2 }"
      >
      <v-icon class="time-icon" dark style="font-size:1.8rem">mdi-clock-time-five-outline</v-icon><span>{{ time }}</span>
      </div>
      {{ title }}
    </v-card-title>

    <v-card-subtitle>
      <p style="margin:0;" v-if="detail">
        {{ detail }}
      </p>
      <p style="margin: 0px 0 0 0;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2; 
                -webkit-box-orient: vertical;
        ">
        {{ subtitle }}
      </p>
    </v-card-subtitle>

  </v-card>
</template>

<script>
export default {
  name: 'ActivityItemCard',
  props: {
    data: {
      type: Object,
      default: null,
    },
    color1: {
      type: String,
      default: '#02443C'
    },
    color2: {
      type: String,
      default: '#BF9D5A'
    },
  },
  data () {
    return {
      image: null,
      time: null,
      title: null,
      subtitle: null,
      detail: null,
      active: false,
      height: 232,
      activityColor1: null,
      activityColor2: null,
    }
  },
  watch: {
    'data.image' () { 
      this.prepareData 
    },
    'data.time' () { 
      this.prepareData 
    },
    'data.title' () { 
      this.prepareData 
    },
    'data.subtitle' () { 
      this.prepareData 
    },
    'data.detail' () { 
      this.prepareData 
    },
    'data.active' () { 
      this.prepareData 
    },
    'data.color1' () { 
      this.prepareData 
    },
    'data.color2' () { 
      this.prepareData 
    },
  },
  mounted () {
    this.prepareData()
  },
  methods: {
    prepareData () {
      this.image = this.data.image
      this.time = this.data.time
      this.title = this.data.title
      this.detail = this.data.detail
      this.subtitle = this.data.subtitle
      this.active = this.data.active ? true : false
      this.activityColor1 = this.data.color1
      this.activityColor2 = this.data.color2
    },
  },
}
</script>

<style scoped>
.time {
  position: absolute;
  height: 60px;
  margin-left: -36px;
  width: 300px;
  border-radius: 0 30px 30px 0;
  padding: 0 0 0 36px;
  font-size: 2rem !important;
  color: white;
  line-height: 60px;
}
.time-icon {
  margin-right: 10px;
  color: white;
  margin-top: -5px !important;
}
.v-card__title {
  font-size: 1.8rem;
  min-height: 77px;
  padding: 45px 0 0 35px !important;
}
.v-card__subtitle {
  font-size: 1.2rem;
  min-height: 62px;
  padding: 20px 0 20px 35px !important;
}
</style>

